import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["controlledVisible", "disabled", "isExpanded", "label", "popupHintId", "setReference"];
import React from 'react';
import { IconHint } from '@op/opds.opux-icons/action';
import { buildVersionedClass } from '@op/opds.opux-utilities';
import Button from '../button/button';
export const TriggerButton = _ref => {
  let {
      disabled,
      isExpanded,
      label,
      popupHintId,
      setReference
    } = _ref,
    referenceProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Button, _extends({
    className: buildVersionedClass('ds-popup-hint-trigger'),
    compact: true,
    disabled: disabled,
    "aria-expanded": isExpanded,
    "aria-controls": popupHintId,
    ghost: true,
    icon: IconHint,
    iconLabel: label,
    iconProps: {
      color: disabled ? 'disabled' : 'default',
      size: 'default'
    },
    ref: setReference,
    type: "button"
  }, referenceProps));
};